import NotificationsController    from "@/js/Webmail/Notifications/NotificationsController";
import FiltersItem                from "./Entities/FiltersItem";
import FiltersData                from "./Entities/FiltersData";
import FiltersHTTPService         from "./HTTP/FiltersHTTPService";
import FiltersMappings            from "./HTTP/FiltersHTTPMappings";

export {FiltersController as default };

/**
* Filters List Controller
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersController {
  /**
   * Filters Data
   *
   * @public
   *
   * @type {FiltersData}
   *
   * @since 7.0.0
   */
  data = new FiltersData();

  /**
   * Filters Mapper Object
   *
   * @privat
   *
   * @type {FiltersMappings}
   *
   * @since 7.0.0
   */
  http_mapping = new FiltersMappings();

  /**
   * Filters HTTP Service Object
   *
   * @privat
   *
   * @type {FiltersHTTPService}
   *
   * @since 7.0.0
   */
  http_service = new FiltersHTTPService();

  /**
   * Fetches Filter from the server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async fetchFilters() {
    let response = await this.http_service.fetchList();

    if (response.success === true) {
      this.http_mapping.mapResults(this.data, response);
    }

    NotificationsController.addMessage('notifications.', response.messages);
    return response.success;
  }

  /**
   * Toggles filter enable/disable status
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter filter item
   *
   * @return {Boolean}
   */
  async toggleFilterEnable(filter) {
    let response = (filter.enabled === true)
      ? await this.http_service.disableFilter(filter)
      : await this.http_service.enableFilter(filter);

    if(response.success) {
      this.http_mapping.mapResults(this.data, response);
    }

    NotificationsController.addMessage('notifications.', response.messages , [filter.name]);
    return response.success
  }

  /**
   * Saves a filter
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter filter item
   *
   * @return {Boolean}
   */
  async saveFilter(filter) {
    let response = await this.http_service.saveFilter(filter);

    if(response.success) {
      this.http_mapping.mapResults(this.data, response);
    }

    NotificationsController.addMessage('notifications.', response.messages , [filter.name]);
    return response.success
  }


  /**
   * Deletes a filter
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter filter item
   *
   * @return {Boolean}
   */
  async deleteFilter(filter) {
    let response = await this.http_service.deleteFilter(filter);

    if(response.success) {
      this.http_mapping.mapResults(this.data, response);
    }

    NotificationsController.addMessage('notifications.', response.messages , [filter.name]);
    return response.success
  }

  /**
   * Checks if the filter given by the id is valid or not
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} filter_id filter id
   *
   * @return {Number}
   */
  isFilterValid(filter_id){
    return this.filters.index[filter_id] ? true : false
  }
}